import { optionType } from "./select";

export const tenureOptions: optionType[] = [
  {
    label: "30 days - 90 days",
    value: "30 days - 90 days",
  },
  {
    label: "90 days - 180 days",
    value: "90 days - 180 days",
  },
  {
    label: "180 days - 365 days",
    value: "180 days - 365 days",
  },
];

export const salaryRangeOptions: optionType[] = [
  {
    label: "80,000 - 150,000",
    value: "80,000 - 150,000",
  },
  {
    label: "150,000 - 500,000",
    value: "150,000 - 500,000",
  },
  {
    label: "550,000 and above",
    value: "550,000 and above",
  },
];

export const locationOptions: optionType[] = [
  {
    label: "Alimosho",
    value: "Alimosho",
  },
  {
    label: "Ajeromi-Ifelodun",
    value: "Ajeromi-Ifelodun",
  },
  {
    label: "Kosofe",
    value: "Kosofe",
  },
  {
    label: "Mushin",
    value: "Mushin",
  },
  {
    label: "Ojo",
    value: "Ojo",
  },
  {
    label: "Oshodi-Isolo",
    value: "Oshodi-Isolo",
  },
  {
    label: "Ikorodu",
    value: "Ikorodu",
  },
  {
    label: "Surulere",
    value: "Surulere",
  },
  {
    label: "Agege",
    value: "Agege",
  },
  {
    label: "Ifako-Ijaiye",
    value: "Ifako-Ijaiye",
  },
  {
    label: "Somolu",
    value: "Somolu",
  },
  {
    label: "Amuwo-Odofin",
    value: "Amuwo-Odofin",
  },
  {
    label: "Lagos Mainland",
    value: "Lagos Mainland",
  },
  {
    label: "Ikeja",
    value: "Ikeja",
  },
  {
    label: "Eti-Osa",
    value: "Eti-Osa",
  },
  {
    label: "Badagry",
    value: "Badagry",
  },
  {
    label: "Apapa",
    value: "Apapa",
  },
  {
    label: "Lagos Island",
    value: "Lagos Island",
  },
  {
    label: "Epe",
    value: "Epe",
  },
  {
    label: "Ibeju-Lekki",
    value: "Ibeju-Lekki",
  },
];

export const smallBusinesLoanOptions: optionType[] = [
  {
    label: "LPO financing",
    value: "LPO financing",
  },
  {
    label: "Invoice discounting",
    value: "Invoice discounting",
  },
];
